<template>
  <Home></Home>
</template>

<script>
import Home from "@/components/Home.vue";

export default {
  components: {
    Home
  },
  name: "course",
  data() {
    return {};
  },
  methods:{
    isMobile() {
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;

      return isMobile;
    }
  },
  created(){
    this.$router.afterEach((to, from) => {
      if (this.isMobile() && !to.meta.h5) {
        // location.href = "/h5/appDownload";
        return;
      }
      this.delay = to.meta.delay > 0;
      setTimeout(() => {
        this.fs = true;
      }, to.meta.delay || 0);
    });
  }
};
</script>